export function buildDisplayNameFromUser(user) {
  if (!user) return "";
  if (typeof user === "string") return user;

  const direct =
    user.nombre_completo ||
    user.nombreCompleto ||
    user.fullName ||
    user.full_name ||
    user.displayName ||
    user.display_name ||
    user.name;

  if (direct && typeof direct === "string" && direct.trim().length > 0) {
    return direct.trim();
  }

  const combined = [user.nombre, user.apellido]
    .filter((part) => typeof part === "string" && part.trim().length > 0)
    .join(" ");
  if (combined.trim().length > 0) {
    return combined.trim();
  }

  const alt =
    user.alias ||
    user.nombre_usuario ||
    user.usuario ||
    user.username ||
    user.email ||
    "";

  return typeof alt === "string" ? alt.trim() : "";
}

export function buildDisplayNameFromMaybeObject(value) {
  if (!value) return "";
  if (typeof value === "string") return value;
  return buildDisplayNameFromUser(value);
}

export function isLikelyUsername(value) {
  if (!value || typeof value !== "string") return false;
  const trimmed = value.trim();
  if (!trimmed) return false;
  if (trimmed.includes(" ")) return false;
  // treat values with punctuation or uppercase as names already
  if (/[A-ZÁÉÍÓÚÑ]/.test(trimmed.slice(1))) return false;
  return true;
}

export function resolveDisplayName({
  primary,
  secondary = [],
  lookup,
  preferNonUsernames = true,
}) {
  const rawCandidates = [primary, ...secondary]
    .map((candidate) => buildDisplayNameFromMaybeObject(candidate))
    .map((candidate) => (typeof candidate === "string" ? candidate.trim() : ""))
    .filter(Boolean);

  if (preferNonUsernames) {
    const nonUsername = rawCandidates.find((candidate) => !isLikelyUsername(candidate));
    if (nonUsername) {
      return nonUsername;
    }
  }

  if (rawCandidates.length > 0) {
    return rawCandidates[0];
  }

  if (lookup && typeof lookup === "function") {
    const value = lookup();
    const resolved = buildDisplayNameFromMaybeObject(value);
    if (resolved && typeof resolved === "string" && resolved.trim()) {
      const trimmed = resolved.trim();
      if (preferNonUsernames && isLikelyUsername(trimmed)) {
        return trimmed;
      }
      return trimmed;
    }
  }
  return "";
}
